import { useEffect } from 'react';
import env from 'src/env';

const LogOut = () => {
    useEffect(() => {
        const ssoVersion = localStorage.getItem('ssoVersion');
        const ssoUrl = ssoVersion === '2' ? env.ssoV2Url : env.ssoV1Url;
        localStorage.clear();

        // SSO's logout page loads this route in an iframe; redirecting would re-enter it.
        if (window.self !== window.top) return;

        window.location.href = `${ssoUrl}/logout`;
    }, []);

    return <></>;
};

export default LogOut;